import { render } from "./VectorAltliklariSvg.vue?vue&type=template&id=7e73c953"
import script from "./VectorAltliklariSvg.vue?vue&type=script&lang=js"
export * from "./VectorAltliklariSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__